import type { IslandLabelProps } from '@/components/IslandLabel'

export interface IslandMotion {
  /** Spring visualDuration, seconds — time to first reach the target size.
   *  NOT Motion's `duration`: a duration-based spring is cut off at t=duration and
   *  snaps the last pixel or two to the target (the pill visibly jumped wider). */
  visualDuration: number
  bounce: number
  /** Time multiplier for inspecting motion in /labs (1 = real time) */
  slow: number
}

// Tuned in /labs/scrolling-text
export const ISLAND_MOTION: IslandMotion = { visualDuration: 0.22, bounce: 0.25, slow: 1 }

/** The left rail's slide-name chip (MediaCard): 8px mono at rest, readable + scrolling on hover.
 *  12px / 8px padding lets a typical name (E019_Spot_01.tiff) fit the 140px pill in mono. */
export const SLIDE_NAME_ISLAND = {
  align: 'right',
  restClassName: 'font-mono text-[8px] leading-[12px]',
  restHeight: 16,
  restMaxWidth: 134,
  expandedClassName: 'font-mono font-medium',
  expandedFontPx: 12,
  expandedPadX: 8,
  expandedMaxWidth: 140,
  className: 'bottom-2 right-2',
  pillClassName: 'bg-text-primary/90 text-text-inverse',
} satisfies Partial<IslandLabelProps>

/** The right rail's rank / score badges: each grows on its OWN hover (no scrolling) */
export const THUMB_BADGE_ISLAND = {
  restHeight: 14,
  // 10px mono at rest → 12px on hover: mono is already legible, so a small step is enough
  expandedFontPx: 12,
  expandedPadX: 6,
  expandedHeight: 20,
  expandedMinWidth: 28,
  pillClassName: 'bg-black/60 text-white',
  // No overshoot: on a pill this small a bounce reads as a glitch, not as life
  motionTuning: { ...ISLAND_MOTION, visualDuration: 0.2, bounce: 0 },
} satisfies Partial<IslandLabelProps>
export const THUMB_BADGE_REST = 'font-mono text-[10px] leading-none'
